module.exports = __webpack_public_path__ + "static/media/ECI88_Casino.e0683abc.png";